import $ 						from 'jquery';
import WallGrid 		from 'javascripts/modules/wall-grid.js';

class LookbookCollection {

	constructor(){
		this.trigger = document.querySelectorAll('[data-trigger="lookbook-collection"]');
		this._init();
	}


	_init(){

	  $(()=>{

	    if( this.trigger.length > 0 ){

				for (let element of this.trigger) {
					console.log(element);
		    	const wallgrid = new WallGrid(element);
		    	//document.roquette.wallgrid = new WallGrid(element);
				}

		  }
	  });
	}

}

export const lookbookCollection = new LookbookCollection();


